import { makeObservable, observable, action, flow } from 'mobx';
import { BalanceSheetReportService } from '../services/balanceSheetReportService';
import { ApiResponse, GlobalStore, GridStore } from '@roc/feature-app-core';
import { downloadDocument } from '@roc/feature-utils';
import moment from 'moment';
import { BalanceSheetReportTabs, balanceSheetReportTabLabels } from '../utils/constants';

export class BalanceSheetReportStore {
  globalStore: GlobalStore;
  service: BalanceSheetReportService;
  balanceSheetReportGridStore: GridStore;
  tab: BalanceSheetReportTabs;

  constructor(globalStore: GlobalStore) {
    this.globalStore = globalStore;
    this.service = new BalanceSheetReportService();
    this.balanceSheetReportGridStore = new GridStore(() => this.fetchDashboard(),
      null,
      50);

    this.tab = BalanceSheetReportTabs.RENTAL_LOANS;
    makeObservable(this, {
      tab: observable,
      setTab: action,
      exportLoans: flow,
      exportReport: flow,
    });
  };

  fetchDashboard = async () => {
    try {
      const filters = {
        ...this.balanceSheetReportGridStore.gridData.meta.filters
      };
      const dropdownFilters = {
        ...this.balanceSheetReportGridStore.gridData.meta.dropdownFilters
      };
      return await this.service.getReport(
        this.tab,
        this.balanceSheetReportGridStore.gridData.meta.pageNumber,
        this.balanceSheetReportGridStore.gridData.meta.pageSize,
        this.balanceSheetReportGridStore.gridData.meta.sortDir,
        this.balanceSheetReportGridStore.gridData.meta.sortBy,
        filters,
        dropdownFilters
      );
    } catch (error) {
      this.globalStore.notificationStore.showErrorNotification({
        message: `Error while fetching ${balanceSheetReportTabLabels[this.tab]} dashboard.`,
      });
    }
  };

  *exportLoans() {
    try {
      const filters = {
        ...this.balanceSheetReportGridStore.gridData.meta.filters
      };
      const dropdownFilters = {
        ...this.balanceSheetReportGridStore.gridData.meta.dropdownFilters
      };
      const response: ApiResponse = yield this.service.downloadReportByType(
        this.tab,
        filters,
        dropdownFilters
      );
      const date = moment(new Date()).format('YYYY-MM-DD');
      downloadDocument(response.data, response.headers, 'download', `${this.tab}_REPORT_${date}.xlsx`);
    } catch (error) {
      this.globalStore.notificationStore.showErrorNotification({
        message: `Error while downloading ${balanceSheetReportTabLabels[this.tab]} reports.`,
      });
    }
  }

  *exportReport() {
    try {
      const response: ApiResponse = yield this.service.downloadReport();
      const date = moment(new Date()).format('YYYY-MM-DD');
      downloadDocument(response.data, response.headers, 'download', `BALANCE_REPORT_${date}.xlsx`);
    } catch (error) {
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error while downloading balance reports.',
      });
    }
  }

  setTab(tab: BalanceSheetReportTabs) {
    this.tab = tab;
  };
}
